import React from "react";
import { Link } from "react-router-dom";
import { lifestyleCategories } from "../articlesData";

const pills = lifestyleCategories.filter((c) => c !== "All");

export default function FashionLifestyle() {
  return (
    <section className="mu-section-lilac" id="lifestyle">
      <div className="container">
        <div className="section-head-row mb-4">
          <div>
            <div className="mu-eyebrow" style={{ color: "var(--mu-purple-700)" }}>Beyond The Music</div>
            <h2 className="section-title">Fashion &amp; Lifestyle</h2>
            <p className="section-sub">
              Explore stories at the intersection of fashion, creativity, culture,
              entertainment, and modern lifestyle.
            </p>
          </div>
          <Link to="/lifestyle" className="btn-mu-outline">Explore Lifestyle &rarr;</Link>
        </div>
        <div className="d-flex flex-wrap gap-3">
          {pills.map((p, i) => (
            <Link to="/lifestyle" className="lifestyle-pill" key={i}>{p}</Link>
          ))}
        </div>
      </div>
    </section>
  );
}
